const slides = {
  dataSlides: [
    {
      id: 1,
      url: '/img/terbaru1.jpg',
    },
    {
      id: 2,
      url: '/img/terbaru2.jpg',
    },
    {
      id: 3,
      url: '/img/terbaru3.jpg',
    },
    {
      id: 4,
      url: '/img/terbaru4.jpg',
    },
    {
      id: 5,
      url: '/img/berita-slider-1.jpg',
    },
    {
      id: 6,
      url: '/img/berita-slider-2.jpg',
    },
    {
      id: 7,
      url: '/img/berita-slider-3.jpg',
    },
    {
      id: 8,
      url: '/img/7jan221.jpg',
    },

    {
      id: 9,
      url: '/img/7jan222.jpg',
    },
    {
      id: 10,
      url: '/img/5jan221.jpg',
    },
    {
      id: 11,
      url: '/img/5jan222.jpg',
    },
    {
      id: 12,
      url: '/img/1jan221.jpg',
    },
    {
      id: 13,
      url: '/img/1jan222.jpg',
    },
    {
      id: 14,
      url: '/img/17des1.jpg',
    },
    {
      id: 15,
      url: '/img/17des2.jpg',
    },
    {
      id: 16,
      url: '/img/dec8121.jpg',
    },
    {
      id: 17,
      url: '/img/dec8221.jpg',
    },
    {
      id: 18,
      url: '/img/29nov1.jpg',
    },
    {
      id: 19,
      url: '/img/29nov2.jpg',
    },
    {
      id: 20,
      url: '/img/beritadmc.jpg',
    },
    {
      id: 21,
      url: '/img/sumurbor1.jpg',
    },
    {
      id: 22,
      url: '/img/sumurbor2.jpeg',
    },
    {
      id: 23,
      url: '/img/pais.jpg',
    },
    {
      id: 24,
      url: '/img/berita-slider-4.jpg',
    },
    {
      id: 25,
      url: '/img/nov21.jpg',
    },
    {
      id: 26,
      url: '/img/nov22.jpg',
    },
    {
      id: 27,
      url: '/img/dec41.jpg',
    },
    {
      id: 28,
      url: '/img/dec42.jpg',
    },
    {
      id: 29,
      url: '/img/berita4.png',
    },
    {
      id: 30,
      url: '/img/berita2.png',
    },
    {
      id: 31,
      url: '/img/berita1.png',
    },
    {
      id: 32,
      url: '/img/berita3.png',
    },
    {
      id: 33,
      url: '/img/berita-slider-5.jpg',
    },
    {
      id: 34,
      url: '/img/berita-slider-6.jpg',
    },
    {
      id: 35,
      url: '/img/april211.jpg',
    },
    {
      id: 36,
      url: '/img/april212.jpg',
    },
    {
      id: 37,
      url: '/img/juni171.jpg',
    },
    {
      id: 38,
      url: '/img/juni172.jpg',
    },
    {
      id: 39,
      url: '/img/juni241.jpg',
    },
    {
      id: 40,
      url: '/img/juni242.jpg',
    },
    {
      id: 41,
      url: '/img/berita-slider-7.jpg',
    },
    {
      id: 42,
      url: '/img/berita-slider-8.jpg',
    },
    {
      id: 43,
      url: '/img/5Januari20223.png',
    },
    {
      id: 44,
      url: '/img/5Januari20224.png',
    },
  ],
};

const news = {
  dataBerita: [
    // 16 Oktober 2020
    {
      id: 1,
      date: '16 Oktober 2020',
      title: `Penyerahan Donasi Sumur Bor Dompet Dhuafa Masjid Al Mannan`,
      content: `<p class="berita-summary">CEO dari DDTekno Iskandar Syamsi berharap Kepada
            pengurus Mesjid dan Warga Agar betul-betul
            Memanfaatkannya dan Sekaligus merawat Serta Menjaganya
            Supaya Bisa di Gunakan dengan maksimal. Hal Senada di
            ungkapkan oleh Ketua DKM Bapak Oye Septori Beliu
            Merasa Sangat Bersyukur Kepada Allah SWT dan kepada
            para donatur khususnya kepada CEO DDTekno beserta
            jajarannya.</p>`,
      image: [
        { id: 1, url: '/img/sumurbor1.jpg' },
        { id: 2, url: '/img/sumurbor2.jpeg' },
      ],
    },
    // 2 November 2020
    {
      id: 2,
      date: '2 November 2020',
      title: `Kerjasama Dompet Dhuafa - PT Masjed Indonesia Digital
            & Baitulmal Tazkia berikan Proteksi Dhuafa untuk 6,000
            Mustahik`,
      content: `<p class="berita-summary">Dompet Dhuafa melalui MPZ DD – Duta Danadyaksa
            Teknologi bekerjasama dengan Baitulmal Tazkia (BMTZ)
            meluncurkan Program Proteksi Dhuafa. Program yang
            direncanakan sebanyak 3 (tiga) tahap ini adalah
            program kepedulian kepada para mustahik (kaum Dhuafa)
            sebagai penyangga bagi para mustahik (kaum Dhuafa),
            apabila mengalami musibah meninggal dunia atau cacat
            tetap.</p>`,
      image: [
        { id: 1, url: '/img/nov21.jpg' },
        { id: 2, url: '/img/nov22.jpg' },
      ],
    },
    // 02 April 2021
    {
      id: 3,
      date: '02 April 2021',
      title: `Aplikasi untuk Masjid, Berikan Kemudahan dalam
            Pengelolaan`,
      content: `<p class="berita-summary">Pada peluncuran Masjed.id, PT. Duta Danadyaksa
            Teknologi (DD Tekno) melakukan penyerahan sedekah
            listrik untuk lima Masjid Cordofa dan penyerahan
            ambulance dengan penyaluran himpunan Infaq & Sedekah
            MPZ dari DD Tekno. Di sela tarhib Ramadan 1442 H,
            turut diperkenalkan ke publik pula aplikasi masjed.id.</p>`,
      image: [
        { id: 1, url: '/img/img-berita-1-a.png' },
        { id: 2, url: '/img/img-berita-1-b.png' },
      ],
    },
    // 16 April 2021
    {
      id: 4,
      date: '16 April 2021',
      title: `Kolaborasi DD Tekno dan K3I Hadirkan Ambulans Gratis
            di Bogor`,
      content: `<p class="berita-summary">Hasil kolaborasi PT. Masjed Indonesia Digital (DD
            Tekno) dengan Koperasi Komunitas Kicau Indonesia (K3I)
            menjawab kebutuhan anggota dengan menghadirkan
            ambulans gratis di Bogor.</p>`,
      image: [
        { id: 1, url: '/img/img-berita-2-a.png' },
        { id: 2, url: '/img/img-berita-2-b.png' },
      ],
    },
    // 21 April 2021
    {
      id: 5,
      date: '21 April 2021',
      title: `DD Tekno Salurkan Proteksi Relawan dan Insani`,
      content: `<p class="berita-summary">PT. Masjed Indonesia Digital (DD Tekno) melakukan
            serah-terima Kartu Proteksi Relawan dan Proteksi
            Insani kepada Disaster Management Center (DMC) dan
            Lembaga Pengembangan Insani (LPI) Dompet Dhuafa pada
            (Rabu, 21/4), kartu proteksi relawan dan proteksi
            insani berasal dari penghimpunan infak dan sedekah.
            Serah-terima proteksi diserahkan langsung oleh CEO PT.
            Masjed Indonesia Digital (DD Tekno), Iskandar Syamsi
            kepada pihak DMC dan LPI.</p>`,
      image: [
        { id: 1, url: '/img/april211.jpg' },
        { id: 2, url: '/img/april212.jpg' },
      ],
    },
    // 3 Mei 2021
    {
      id: 6,
      date: '03 Mei 2021',
      title: `DD Tekno Luncurkan Gerakan 1.000 Wakaf Sumur Air Bor`,
      content: `<p class="berita-summary">Alhamdulillah melalui Mitra Pengelola Zakat (MPZ)
            Dompet Dhuafa (DD)- Masjed Indonesia Digital
            menyalurkan wakaf pengadaan air bersih berupa sumur
            bor bagi Pondok Pesantren Nurul Falah Haromaen 2 yang
            berlokasi di Cinangka, Serang, Banten.</p>`,
      image: [
        { id: 1, url: '/img/img-berita-3-a.png' },
        { id: 2, url: '/img/img-berita-3-b.png' },
      ],
    },
    // 21 Mei 2021
    {
      id: 7,
      date: '21 Mei 2021',
      title: `DD Tekno Salurkan Bantuan untuk Rakyat Palestina`,
      content: `<p class="berita-summary">Melihat aksi kekejaman kemanusiaan oleh militer Israel
            terhadap jamaah terawih di Masjid Al-Aqsa saat Ramadan
            lalu, Unit Sosial Bisnis Fund Raising Digital Yayasan
            Dompet Dhuafa Republika, PT Masjed Indonesia Digital
            (DD Tekno) melakukan penghimpunan donasi.</p>`,
      image: [
        { id: 1, url: '/img/img-berita-4-a.png' },
        { id: 2, url: '/img/img-berita-4-b.png' },
      ],
    },
    // 06 Juni 2021
    {
      id: 8,
      date: '06 Juni 2021',
      title: `Akses ke Faskes Sulit, Dompet Dhuafa Sumbangkan
            Ambulans untuk Warga Desa Tanjung Raya`,
      content: `<p class="berita-summary">Pada peluncuran Masjed.id, PT. Duta Danadyaksa
            Teknologi (DD Tekno) melakukan penyerahan sedekah
            listrik untuk lima Masjid Cordofa dan penyerahan
            ambulance dengan penyaluran himpunan Infaq & Sedekah
            MPZ dari DD Tekno. Di sela tarhib Ramadan 1442 H,
            turut diperkenalkan ke publik pula aplikasi masjed.id.</p>`,
      image: [
        { id: 1, url: '/img/img-berita-5-a.png' },
        { id: 2, url: '/img/img-berita-5-b.png' },
      ],
    },
    // 17 Juni 2021
    {
      id: 9,
      date: '17 Juni 2021',
      title: `Dompet Dhuafa bersama Ponpes Ilmu Al-Qur’an Kembangkan
            Zakat Produktif Berbasis Pesantren`,
      content: `<p class="berita-summary">Dompet Dhuafa melalui PT Masjed Indonesia Digital (DD
            Tekno) melakukan serah terima pengembangan zakat
            produktif dan perkebunan berbasis pesantren bersama
            Pondok Pesantren Ilmu Al-Qur’an di Desa Selaraja,
            Kecamatan Warung Gunung, Kabupaten Lebak, Banten,
            Kamis (17/6/2021)</p>`,
      image: [
        { id: 1, url: '/img/juni171.jpg' },
        { id: 2, url: '/img/juni172.jpg' },
      ],
    },
    // 24 Juni 2021
    {
      id: 10,
      date: '24 Juni 2021',
      title: `Roadshow: Dompet Dhuafa Go To Masjed.id, Bangun Masjid
            Sebagai Peradaban Umat`,
      content: `<p class="berita-summary">Iskandar Syamsi selaku CEO PT Duta Danadyaksa
            Teknologi (DD Tekno) mengatakan, “Dalam rangka ini
            masuk program Roadshow Go To Masjed.id yang kita
            jalankan masuk kedalam aplikasi Masjed.id. Insyallah
            kita bersama-sama memakmurkan masjid-masjid di seluruh
            Indonesia dan akan banyak program-program seperti ini
            yang diberikan melalui aplikasi Masjed.id kepada yang
            berhak.Semoga kita semua menjadikan masjed sebagai
            pusat tempat aktifitas keumatan dalam menggapai
            kebaikan urusan dunia dan kebaikan urusan akhirat
            serta dijauhi dari siksa neraka, Allahumma aamiin”.</p>`,
      image: [
        { id: 1, url: '/img/juni241.jpg' },
        { id: 2, url: '/img/juni242.jpg' },
      ],
    },
    // 02 Juli 2021
    {
      id: 11,
      date: '02 Juli 2021',
      title: `DD Tekno Penyaluran ZIS Donasikan 100 Kursi Roda saat
            Milad 28 Tahun Dompet Dhuafa, "KolaborAksi Bangun
            Negeri"`,
      content: `<p class="berita-summary">Rangkaian acara milad ke 28 tahun Dompet Dhufa yang
            dilaksanakan secara virtual (online) melalui channel
            YouTube Dompet Dhuafa TV pada Jumat (02/07/202),
            Dompet Dhuafa melalui unit sosial bisnis fundraising
            digitalnya yaitu DD Tekno berinisasi untuk memberikan
            penyaluran himpunan ZIS DD Tekno sebanyak seratus unit
            Kursi Roda pada program 100 Kursi Roda Road Show DD
            GOTO Masjed.id.</p>`,
      image: [
        { id: 1, url: '/img/img-berita-6-a.png' },
        { id: 2, url: '/img/img-berita-6-b.png' },
      ],
    },
    // 16 Juli 2021
    {
      id: 12,
      date: '16 Juli 2021',
      title: `DD Tekno Hadirkan Proteksi Dhuafa untuk Para Relawan
            Covid-19`,
      content: `<p class="berita-summary">Tebar kebaikan saling tolong menolong sesama anak
            bangsa pada masa pandemi covid 19 saat ini dengan
            penghimpunan dan penyaluran ZISWAF secara inklusi
            keuangan finansial technologi (fintech) di aplikasi
            masjed.id dan Mumuapps.id memberikan Bantuan santunan
            kepada para dhuafa yang terkena musibah meninggal
            dunia, kecelakaan, maupun sakit.</p>`,
      image: [
        { id: 1, url: '/img/img-berita-7-a.png' },
        { id: 2, url: '/img/img-berita-7-b.png' },
      ],
    },
    // 18 September 2021
    {
      id: 13,
      date: '18 September 2021',
      title: `Program Muliakan Yatim 'Beras Untuk Yatim Piatu' &
            Program 1.000 Baju Baru OOTD Untuk Yatim Piatu`,
      content: `<p class="berita-summary">Donasi baju yang diberikan oleh DD Tekno merupakan
            ikhtiar menjawab tantangan yang terjadi dengan mencoba
            menghadirkan sebuah solusi dari kenaikan jumlah anak
            yatim piatu di saat pandemi ini . Dompet Dhuafa
            melalui DD Tekno mencoba Memuliakan Yatim piatu dengan
            memberikan pakaian yang modis kekinian dari El Zuhra,
            dalam memberikan kepercayaan diri mereka di masyarakat
            bahwa kami tetap memikirkan dan berkepedulian saat
            kondisi Social ekonomi berdampak pandemi covid saat
            ini .</p>`,
      image: [
        { id: 1, url: '/img/muliakan-yatim1.png' },
        { id: 2, url: '/img/muliakan-yatim2.png' },
      ],
    },
    // 19 Oktober 2021
    {
      id: 14,
      date: '19 Oktober 2021',
      title: `Penyaluran Renovasi Masjid Agung Demak & Baju El Zuhra
            untuk Takmir Masjid Agung Demak`,
      content: `<p class="berita-summary">Tebar kebaikan saling tolong menolong sesama anak
            bangsa pada masa pandemi covid 19 saat ini dengan
            penghimpunan dan penyaluran ZISWAF secara inklusi
            keuangan finansial technologi (fintech) di aplikasi
            masjed.id dan Mumuapps.id memberikan Bantuan santunan
            kepada para dhuafa yang terkena musibah meninggal
            dunia, kecelakaan, maupun sakit.</p>`,
      image: [
        { id: 1, url: '/img/demak1.png' },
        { id: 2, url: '/img/demak2.png' },
      ],
    },
    // 26 November 2021
    {
      id: 15,
      date: '26 November 2021',
      title: `DDTekno menyalurkan bantuan untuk korban banjir
            bandang Kalimantan Barat berupa uang sebesar Rp
            72,500,000 serta 150pcs baju eL Zuhra melalui DMC`,
      content: `<p class="berita-summary">Sebelumnya Kalimantan Barat terendam banjir dari 21
            Oktober lalu. Kemudian pada Sabtu (6/11/2021)
            permukaan air kembal naik dan merendam 12 kecamatan,
            mulai dari Kecamatan Kayan Hulu, Kayan Hilir, Binjai
            Hulu, Sintang, Tempunak, Sepauk, Ketungau Hilir,
            Dedai, Serawai, Ambalau, Sei Tabelian, dan Kelam
            Permai. Data pada hari, Sabtu (13/11/2021), pukul
            17.00 WIB, sebanyak 10.381 KK atau 33.221 jiwa masih
            mengungsi.</p>`,
      image: [
        { id: 1, url: '/img/pais.jpg' },
        { id: 2, url: '/img/beritadmc.jpg' },
      ],
    },
    // 29 November 2021
    {
      id: 16,
      date: '29 November 2021',
      title: `IFI Luluskan 16 Muslim Fashion Designer`,
      content: `<p class="berita-summary">Di tengah pandemi saat ini menuntut UMKM untuk
            bertransformasi digital agar bisnisnya dapat terus
            bertahan dan bertumbuh. Apalagi saat ini, penetrasi
            internet di Tanah Air telah menjangkau 73,7 persen
            atau 202,6 juta orang. PT. Masjed Indonesia Digital
            (DD Tekno) mendorong geliat dunia fesyen di tengah
            pandemi Covid-19 melalui perkembangan teknologi. DD
            Tekno juga mendukung keberlangsungan ekosistem dunia
            fesyen digital. “Membantu menyiapkan teknologi dan
            ekosistem market untuk menunjang pendidikan IFI dan
            alumni untuk siap berkontribusi di dunia fesyen muslim
            nasional maupun Internasional. menyongsong Indonesia
            menjadikan kiblat fesyen muslim di dunia,” ujar CEO DD
            Tekno Iskandar Syamsi.</p>`,
      image: [
        { id: 1, url: '/img/29nov1.jpg' },
        { id: 2, url: '/img/29nov2.jpg' },
      ],
    },
    // 4 Desember 2021
    {
      id: 17,
      date: '4 Desember 2021',
      title: `DDTekno Menyalurkan Dana Infak Untuk Kendaraan
            Pengumpul Sampah dan Budidaya Ternak Maggot Kepada LAZ
            DASI NTB.`,
      content: `<p class="berita-summary">Penyaluran tersebut dilakukan dalam acara Musyawarah
            Rencana Kerja LAZ DASI NTB yang diselenggarakan di
            Holiday Resort Hotel Lombok, NTB. DD Tekno menyalurkan
            donasi senilai Rp.328.800.000,- dengan rincian uang 30
            Juta untuk kebutuhan berupa Kendaraan Pengumpul Sampah
            dan uang sebesar Rp.298.800.000,- untuk kebutuhan
            Budidaya Ternak Maggot diantaranya pengadaan bahan
            baku, workshop, FGD, pembuatan aplikasi serta upah
            tenaga kerja lapangan.</p>`,
      image: [
        { id: 1, url: '/img/dec41.jpg' },
        { id: 2, url: '/img/dec42.jpg' },
      ],
    },
    // 8 Desember 2021
    {
      id: 18,
      date: '8 Desember 2021',
      title: `DD Tekno bersama LinkAja Syariah dalam program
            masjedAja, Salurkan donasi Kemanusiaan Dan untuk
            Masyarakat Terdampak Erupsi Semeru LinkAja Salurkan
            Renovasi Masjid dan Jembatan`,
      content: `<p class="berita-summary">PT Masjed Indonesia Digital (DDTekno) bersama Link
            Aja Syariah dalam program masjedAja Pada Rabu
            (08/12/2021), menyalurkan dana infak sebesar Rp
            60.500.000,- dalam bentuk uang tunai senilai 50 Juta
            Rupiah dan 70 pcs baju baru OOTD El Zuhra senilai 10,5
            Juta Rupiah kepada Disaster Managament Center (DMC)
            Dompet Dhuafa di Kantor DMC yang bertempat di Ciputat,
            Tangsel, Banten.</p>`,
      image: [
        { id: 1, url: '/img/dec8121.jpg' },
        { id: 2, url: '/img/dec8221.jpg' },
      ],
    },
    // 17 Desember 2021
    {
      id: 19,
      date: '17 Desember 2021',
      title: `Pulihkan UMKM Pasca-Pandemi, DD Tekno Salurkan
            Fasilitas Kelengkapan sarana Foodcourt dan Toko Usaha
            Serambi Masjed serta Proteksi Jiwa Tafakul Syariah
            Berbasis DKM Masjid`,
      content: `<p class="berita-summary">Dompet Dhuafa melalui start-up digital fundraising
            sosial bisnisnya yaitu PT Masjed Indonesia Digital
            (DDTekno), pada Jumat (17/12/2021) dalam program
            Pemberdayaan UMKM menyalurkan bantuan infak/sedekah
            yang akan digunakan untuk sarana kelengkapan foodcourt
            dan toko usaha serambi masjid kepada DKM Masjid Jabal
            Nur sebesar 60 Juta Rupiah yang bertempat di Masjid
            Jabal Nur Desa Giri Mekar, Kecamatan Cilengkrang,
            Kabupaten Bandung, Jawa Barat.</p>`,
      image: [
        { id: 1, url: '/img/17des1.jpg' },
        { id: 2, url: '/img/17des2.jpg' },
      ],
    },
    // 1 Januari 2022
    {
      id: 20,
      date: '1 Januari 2022',
      title: `DDTEKNO mengangkat tema tahun 2022 yaitu Digital Hub
            Philantrophy Empowering Halal Society 5.0 dalam
            Memperluas Kebaikan dan kemudahan Berbasis Masjed`,
      content: `<p class="berita-summary">Dompet Dhuafa melalui start-up digital fundraising
            sosial bisnisnya yaitu PT Masjed Indonesia Digital
            (DDTekno), pada Jumat (17/12/2021) dalam program
            Pemberdayaan UMKM menyalurkan bantuan infak/sedekah
            yang akan digunakan untuk sarana kelengkapan foodcourt
            dan toko usaha serambi masjid kepada DKM Masjid Jabal
            Nur sebesar 60 Juta Rupiah yang bertempat di Masjid
            Jabal Nur Desa Giri Mekar, Kecamatan Cilengkrang,
            Kabupaten Bandung, Jawa Barat.</p>
            <ol class="yaitu">
            <li>Innovation Philantrophy Digital Society 5.0</li>
            <li>SDGs Empowering Islamic Social Fund</li>
            <li>
              Persiapan Indonesia Sebagai Kiblat Fashion Muslim
              Global Eksyar Hub
            </li>
            <li>KolaborAksi Bangkit Bersama</li>
          </ol>`,
      image: [
        { id: 1, url: '/img/1jan221.jpg' },
        { id: 2, url: '/img/1jan222.jpg' },
      ],
    },
    // 5 Januari 2022
    {
      id: 21,
      date: '5 Januari 2022',
      title: `DDTekno Kembangkan UMKM Keumatan dan Kerakyatan
            Melalui Aplikasi Masjed.id`,
      content: `<p class="berita-summary">PT. Masjed Indonesia Digital (DD Tekno) melalui
            Global Digital Philanthropy Hub Empowering Halal
            Society 5.0 berinovasi menjawab tantangan era digital
            dengan meluncurkan ekosistem Green Digital dengan
            Teknologi Cerdas melalui aplikasi ekosistem masjed.id
            dengan tema back to Masjed bersama para mitra
            pendukung yang bertempat di Gedung Nareswara Smesco,
            Gatot Subroto, Pancoran, Jakarta Selatan.</p>
            `,
      image: [
        { id: 1, url: '/img/5jan221.jpg' },
        { id: 2, url: '/img/5jan222.jpg' },
        { id: 3, url: '/img/5Januari20223.png' },
        { id: 4, url: '/img/5Januari20224.png' },
      ],
    },
    // 7 Januari 2022
    {
      id: 22,
      date: '7 Januari 2022',
      title: `DD Tekno dan Masjed.id Hadirkan Program Sumur Bor Air
            Back To Masjed untuk Keumatan dan Kerakyatan`,
      content: `<p class="berita-summary">Dompet Dhuafa melalui start-up digital fundraising
            sosial bisnisnya yaitu PT Masjed Indonesia Digital
            (DDTekno) di aplikasi masjed.id pada Jumat
            (07/01/2022) menyalurkan serah terima infak sebesar Rp
            61.340.000,- untuk pengadaan Fasilitas Air Bersih
            berupa Sumur Bor untuk Masjid Baitul Ihsan dan Pondok
            Pesantren Tahfidz Entrepreneur Madinatur Rahmah,
            Kecamatan Tenjo, Bogor, Jawa Barat. Sebelumnya DDTekno
            telah memberikan donasi sebesar Rp 100 Juta untuk
            pembangunan Masjid Baitul Ihsan tersebut.</p>
            `,
      image: [
        { id: 1, url: '/img/7jan221.jpg' },
        { id: 2, url: '/img/7jan222.jpg' },
      ],
    },
    // 25 April 2022
    {
      id: 23,
      date: '25 April 2022',
      title: `MULIAKAN ANAK YATIM, DDTEKNO DAN EL ZUHRA SALURKAN
            ZAKAT FI SABILILAH`,
      content: `<p class="berita-summary">PT Masjed Indonesia Digital (DDTekno) melalui
            aplikasi MASJED pada hari Senin, 25 April 2022 telah
            menyalurkan dana zakat fisabililah sebesar total Rp.
            66,500,000 dan juga bersama El Zuhra Fashion Muslim
            Society, DDTekno menyalurkan total 425 pcs Baju
            Lebaran 'OOTD' kepada Anak Yatim Piatu dan Dhuafa yang
            tersebar di Kota Bandung ( Yayasan Mamba'ul Huda,
            Yayasan Rumah Amal Al-Hikmah, dan Rumah Yatim dan
            Dhuafa Ar-Rifqi ) dan Banten ( Pondok Pesantren Ilmu
            Al-Qur'an dan Pondok Pesantren As-Syifa ). Program
            penyaluran ini adalah wujud nyata Gerakan Memakmurkan
            Masjid dan Penguatan Ekonomi Ummat yang diusung oleh
            PT Masjed Indonesia Digital.</p>
            `,
      image: [
        { id: 1, url: '/img/terbaru1.jpg' },
        { id: 2, url: '/img/terbaru2.jpg' },
        { id: 3, url: '/img/terbaru3.jpg' },
        { id: 4, url: '/img/terbaru4.jpg' },
      ],
    },
    // 29 – 30 September 2022
    {
      id: 24,
      date: '29 – 30 September 2022',
      title: `Muliakan Anak Yatim, Yayasan Dompet Yatim dan Mesjid
            Bersama Baznas Kota Tangerang Selatan Salurkan Dana
            Infaq Untuk 100 Anak Yatim Binaan`,
      content: `<p class="berita-summary">Program Islamic Holiday Camp memberikan 100 Baju baru
            Outfit of The Day (OOTD) dari El Zuhra yang merupakan
            Fashion Muslim Society dari dana infak yang terkumpul
            melalui LAZ YAYASAN DOMPET YATIM DAN MESJID (YDYM),
            yang selanjutnya didonasikan kepada anak yatim Binaan
            Baznas Kota Tangerang Selatan senilai Rp.
            50,000,000,-. Bersama dengan kegiatan tersebut,
            Yayasan Dompet Yatim dan Mesjid juga menyalurkan dana
            infaq berupa bantuan tangan palsu untuk penyandang
            disabilitas kepada Bunga Pratiwi binti Oji Prayogi.
            Penyerahan bantuan ini dilakukan oleh Ketua LAZ YDYM
            Muhammad Bagir dan didampingi langsung oleh Walikota
            Tangerang Selatan Benyamin Davnie kepada Bunga
            Pratiwi.</p>
            `,
      image: [
        { id: 1, url: '/img/september1.JPG' },
        { id: 2, url: '/img/september2.JPG' },
      ],
    },
    // 02 Oktober 2022
    {
      id: 25,
      date: '2 Oktober 2022',
      title: `DDTekno dan Masjed Apps Salurkan Dana Infaq Operasional Masjid Baitul Ihsan untuk Keumatan dan Kerakyatan.`,
      content: `<p class="berita-summary">Dalam kesempatan ini DDTekno bersama aplikasi Masjed menyalurkan Dana Infaq 
      sebesar Rp. 6.134.000,- ke Masjid Baitul Ihsan dan Pondok Pesantren Tahfidz Entrepreneur Madinatur Rahmah, 
      Kecamatan Tenjo, Bogor, Jawa Barat, Minggu 2 Oktober 2022. Dana tersebut disalurkan untuk keperluan operasional 
      masjid Baitul Ihsan, sebelumnya DDTekno bersama aplikasi Masjed telah memberikan donasi sebesar Rp. 100.000.000,- 
      untuk pembangunan Masjid Baitul Ihsan dan Rp. 61.340.000 untuk pengadaan Fasilitas Air Bersih (Sumur Bor). 
      Acara yang dihadiri langsung oleh Deputi Gubernur Bank Indonesia, Juda Agung, Ph.D. didampingi oleh Dodi Budi Waluyo selaku Deputi Gubernur Bank Indonesia, 
      Herawanto perwakilan dari Bank Indonesia Jabar, Heru perwakilan dari Bank Indonesia Bandung, Yudhi Utomo selaku Camat Tenjo, Edi Witjara selaku Direktur Utama PT INTI, 
      Mayjen TNI Rudi Yulianto, Prof. Dr. KH. Nasarudin Umar, M.A, Iskandar Syamsi selaku Founder dan CEO PT Masjid Indonesia Digital beserta Dr. Ir. Akbar Tanjung selaku 
      tokoh Nasional dan beberapa perwakilan pengusaha atau tamu undangan lainnya. Bantuan tersebut merupakan hasil donasi yang terkumpul dari para Muzzaki melalui himpunan 
      dana pada aplikasi Masjed sebagai aplikasi ekosistem Masjed terbesar di Indonesia. Oleh karena itu, DDTekno berharap melalui aplikasi ekosistem Masjed terbesar di Indonesia 
      menjadikan salah satu cara memakmurkan masjid dan membangun peradaban umat melalui masjid dengan teknologi kekinian di zamannya.</p>`,
      image: [
        { id: 1, url: '/img/2Oktober2022-1.jpeg' },
        { id: 2, url: '/img/2Oktober2022-2.jpeg' },
        { id: 3, url: '/img/2Oktober2022-3.jpeg' },
        { id: 4, url: '/img/2Oktober2022-4.jpeg' },
      ],
    },
    // 04 Oktober 2022
    {
      id: 26,
      date: '4 Oktober 2022',
      title: `Yayasan Dompet Yatim dan Mesjid bersama APLIKASI MASJED
      GELAR SEMINAR SOCIETY 5.0 ECOSYSTEM MASJED "DIGITALISASI MASJED ZAMAN NOW"`,
      content: `<p class="berita-summary">Perkembangan teknologi dalam berbagai 
      aspek kehidupan manusia semakin pesat. Salah satunya adalah society 5.0. 
      Hal ini membuat, Lembaga Amil Zakat Dompet Yatim dan Masjid bersama 
      Aplikasi Masjed menyelenggarakan Seminar 5.0 Ecosystem Masjed 
      ‘Digitalisasi Masjed Zaman Now’ dalam mewujudkan pembangunan 
      berkelanjutan berbasis masjed dan lingkungan yang bertempat 
      di Khadijah Learning Center, Serpong, Kota Tangerang Selatan. 
      Kegiatan seminar diadakan selama 2 hari pada Rabu dan Kamis 
      (4 dan 5 Oktober 2022). Seminar ini, mengangkat tema Pemberdayaan Ekonomi 
      melalui Penguatan Aspek Kelembagaan, Penguatan SDM, 
      Penguatan Infrastruktur dan Penguatan Jaringan Berdasarkan Prinsip
       3A (Aman Syari’i, Aman Regulasi dan Aman NKRI) dengan Pelayanan 
       Berbasis Digital Technologies For Transparency And Accountability.</p>`,
      image: [
        { id: 1, url: '/img/4Oktober2022-1.jpeg' },
        { id: 2, url: '/img/4Oktober2022-2.jpeg' },
      ],
    },
    // 6 Desember 2022
    {
      id: 27,
      date: '6 Desember 2022',
      title: `Launching MASJED RESPONS BENCANA dan Pengukuhan RELAWAN MASJED RESPONS BENCANA`,
      content: `<p class="berita-summary">Cianjur, Jawa Barat – Selasa, 6 Desember 2022 bertempat di Kampung Seuseupan, Desa Wangunjaya, Kec Cugenang, Kab Cianjur, Jawa Barat telah dilaksanakan acara launching Masjed Respons Bencana (MRB) dan juga pengukuhan Relawan Masjed Respons Bencana. Acara ini bertepatan dengan diperingatinya Hari Relawan Sedunia, tanggal 5 Desember 2022 lalu. Kegiatan Relawan Masjed Respons Bencana ini diapresiasi langsung oleh Bapak Haji Herman Suherman, selaku Bupati Cianjur.
      “Mengucapkan terima kasih kepada tim relawan MRB yang telah membantu warga masyarakat Cianjur yang terkena bencana alam. Kegiatan ini luar biasa, saya berikan apresiasi mudah – mudahan apa yang telah dilakukan dan yang diberikan ke masyarakat Cianjur menjadi amal ibadah yang diterima oleh Allah Subhanallau Wataa’la. Dan mohon do’anya Cianjur cepat pulih, bangkit, dan seperti sedia kala.” Kata Bapak Haji Herman Suherman selaku Bupati Cianjur.
      Launching Masjed Respons Bencana (MRB) dan Pengukuhan Relawan Masjed Respons Bencana ini dibarengi dengan kegiatan pendirian Posko Dapur Umum untuk memenuhi kebutuhan pangan para penyintas gempa Cianjur yang terjadi di tanggal 21 November 2022 lalu, kegiatan Dapur Umum ini berlangsung sejak tanggal 22 November 2022 dan merupakan Posko Dapur Umum pertama yang didirikan di Kampung Seuseupan, untuk membantu para penyintas gempa Cianjur.</p>`,
      image: [
        { id: 1, url: '/img/6Desember2022-1.png' },
        { id: 2, url: '/img/6Desember2022-2.png' },
        { id: 3, url: '/img/6Desember2022-3.png' },
        { id: 4, url: '/img/6Desember2022-4.png' },
      ],
    },
  ],
};

export default {
  ...slides,
  ...news,
};
